import React, { useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { PlusIcon } from 'lucide-react';
import { SectionHeading } from '../SectionHeading';
import { faqs } from '../../data/landing';
export function Faq() {
  const [open, setOpen] = useState<number | null>(0);
  return <section className="bg-brand-soft px-5 py-16 md:py-24" data-id="element-82" data-mp="1223klf4l3e3y">
      <div className="mx-auto max-w-3xl" data-id="element-83" data-mp="124g9ydco8qr1">
        <SectionHeading title="Lo que más nos preguntan" data-id="element-84" data-mp="1prxupoxiqoki" />
        <ul className="mt-12 space-y-3" data-id="element-85" data-mp="1puk1hmcl501o">
          {faqs.map((f, i) => {
          const isOpen = open === i;
          return <li key={f.question} className="overflow-hidden rounded-2xl bg-white shadow-sm" data-id="element-86" data-mp="1g3653nfxkgcr" data-mpi={i}>
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} aria-controls={`faq-${i}`} className="flex w-full items-center justify-between gap-4 px-6 py-5 text-left text-base font-bold text-brand transition-colors duration-150 ease-out hover:text-brand-strong focus:outline-none focus-visible:ring-2 focus-visible:ring-inset focus-visible:ring-brand md:text-lg" data-id="element-87" data-mp="1l0pk4pkgcx5r">
                  {f.question}
                  <span className={`flex h-7 w-7 shrink-0 items-center justify-center rounded-full bg-gold transition-transform duration-200 ease-out ${isOpen ? 'rotate-45' : ''}`} data-id="element-88" data-mp="2yhd1d6daz3ym">
                    <PlusIcon className="h-4 w-4 text-brand" strokeWidth={3} aria-hidden="true" data-id="element-89" data-mp="32glt65os8rrj" />
                  </span>
                </button>
                <AnimatePresence initial={false} data-id="element-90" data-mp="3hcjvy6t7oucq">
                  {isOpen && <motion.div id={`faq-${i}`} initial={{
                height: 0,
                opacity: 0
              }} animate={{
                height: 'auto',
                opacity: 1
              }} exit={{
                height: 0,
                opacity: 0
              }} transition={{
                duration: 0.2,
                ease: [0.23, 1, 0.32, 1]
              }} data-id="element-91" data-mp="3cgkxtri2zxz4">
                      <p className="px-6 pb-6 text-base leading-relaxed text-charcoal" data-id="element-92" data-mp="2bqznzqro7zwf">{f.answer}</p>
                    </motion.div>}
                </AnimatePresence>
              </li>;
        })}
        </ul>
      </div>
    </section>;
}